import { FormControl } from "@angular/forms";

export function noLettersValidator (control: FormControl) {
  const text = (control.value || "").trim(),
   isValid = /[a-zA-Z]+/.test(text);
  return isValid ? null : { "noLetters": true };
}
